export default {
  categoryInfo: {
    mainTitle: 'Kefalet Sigortası ',
    description: {
      title: 'Kefalet Sigortası Nedir?',
      content: [
        'Kefalet sigortası, borçlunun sözleşmeden veya kanunen doğan yükümlülüklerini yerine getirememesi sonucunda işverene veya alacaklıya karşı düzenlemiş olduğu kefalet senedi bedeline kefil olmasıdır.',
        'Kefalet sigortası, teminat mektubu işlevine sahip olan sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: 'Kefalet Sigortası Teminat Türleri Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Avans Ödeme Teminatı',
            'İmalat / Bakım / Onarım Teminatı',
            'Emniyeti Suistimal Teminatı',
            'Gümrük ve Mahkeme Teminatı',
            'İhaleye Katılım (Geçici Teminat) Teminatı',
            'Ödeme Teminatı',
            'Performans Teminatı',
            'Sözleşme Teminat',
            'Kamu İhaleleri Teminatı',
            'Kamu Alacakları Teminatı poliçe kapsamında sunulmaktadır.'
          ]
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Kefalet Sigortası Ne İşe Yarıyor?',
      content: [
        {
          paragraph:
            'Teminat ve kefalet konusunda sorun yaşayan işletmeler için hazırlanan sigorta ürünü;',
          subList: [
            'İşlemlerinizi kolaylaştırır.',
            'Sektörlerin bankalardaki kredi limitlerinin tamamını nakit kredi olarak kullanılmasını sağlar.',
            'Lehtarın maruz kalabileceği zararları karşılamayı taahhüt eder.',
            'İlave kredi kapasitesi oluşturulmasına katkıda bulunur.',
            'Özellikleri itibari ile teminat mektubunun kullanıldığı her alanda kullanılabilir.',
            'Kamu tarafından açılan tüm ihalelerde, kefalet sigortası ile verilen kefalet senetleri, banka teminat mektubu yerine geçer.'
          ]
        }
      ]
    },
    {
      title: 'Kefalet Sigortası Kimin Adına Düzenlenir?',
      content: [
        {
          paragraph:
            'Kefalet Senedi ile teminat verilen taraf, yani “Lehdar” adına poliçe düzenlenir.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketi talebi onayladıktan sonra, lehdara verilmek üzere kefalet senedi düzenlemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kefalet Sigortası Genel Şartları Kapsamında Hangi Konular Yer Alır?',
      content: [
        {
          paragraph:
            'Sigorta poliçeleri düzenlenirken genel şartlar baz alınmaktadır. Genel şartlar kapsamında yer alan konular:',
          subList: [
            'Sigortanın Konusu',
            'Teminat Türleri Ve Tanımlar',
            'Kefalete İlişkin Koşullar Ve Tazminat',
            'Rizikonun Gerçekleşmesi Halinde Hak Ve Yükümlülükler',
            'Tazminat Tutarı',
            'Halefiyet',
            'Rücu',
            'Mesleki Faaliyetin Sona Ermesi',
            'Ticari Ve Mesleki Sırların Saklı Tutulması',
            'Yetkili Mahkeme gibi konular yer almaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Kefalet Sigortası Yapan Şirketler Hangileridir?',
      content: [
        {
          paragraph:
            'Kefalet sigortası tüm sigorta şirketlerinde bulunmasa da alokasko.com alarak siz sigortalılarımızın tüm ihtiyaçlarında yanında olabilmek için Quick Sigortadan Kefalet sigortası temin edebilmekteyiz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kefalet Senedi Nasıl Alınır?',
      content: [
        {
          paragraph: null,
          subList: [
            'Teminat senedi almak isteyen kurumlar, Alokasko.com üzerinden online başvuru formunu doldurarak kefalet sigortası başvurusunu yapabilir.',
            'Kefalet sigortası yaptıracak olan şirket gerekli bilgiler ile birlikte hesap özetleri vb. olmak üzere şirketine ait finansal dokümanları ileterek başvurusunu tamamlayabilir.',
            'Finansal incelemelerden sonra sigorta şirketi gerekli sözleşme ve poliçeleri düzenler.',
            'Sigorta şirketi talebi onayladıktan sonra, lehdara verilmek üzere bir kefalet senedi düzenler.',
            'Kefalet sigortası yaptıran şirket yükümlülüklerini yerine getirmezse, lehdarın talebi üzerine sigorta şirketi devreye girer.'
          ]
        }
      ]
    },
    {
      title: 'Kefalet Sigortası Ücretleri Ne Kadar?',
      content: [
        {
          paragraph:
            'Kefalet sigortası fiyatları istenen teminatlara göre değişiklik göstermektedir. ',
          subList: null
        },
        {
          paragraph:
            'Sizde kefalet sigortası fiyatlarını merak ediyorsanız (0216) 371 67 77 numaralı hattı arayarak veya başvuru formunu doldurarak uzmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
